import Vue from 'vue'

const trackedBill = {
  state: {
    // selectedTrackedBillConcernId: 0,
    // concernRequestCount: 0,
    // selectedTrackedBillConcern: {},
    // selectedTrackedBillCreatedById: 0,
    // createdByRequestCount: 0,
    // selectedTrackedBillCreatedBy: {},
    // selectedTrackedBillPositionId: 0,
    // positionRequestCount: 0,
    // selectedTrackedBillPosition: {},
    // selectedTrackedBillPriorityId: 0,
    // priorityRequestCount: 0,
    // selectedTrackedBillPriority: {},
    // selectedTrackedBillUpdatedById: 0,
    // updatedByRequestCount: 0,
    // selectedTrackedBillUpdatedBy: {},
    selectedTrackedBillCommentsId: 0,
    commentsRequestCount: 0,
    selectedTrackedBillComments: [],
    selectedTrackedBillMatchingSharedId: 0,
    matchingSharedRequestCount: 0,
    selectedTrackedBillMatchingShared: [],
    selectedTrackedBillDocumentsId: 0,
    documentsRequestCount: 0,
    selectedTrackedBillDocuments: [],
    selectedTrackedBillLinksId: 0,
    linksRequestCount: 0,
    selectedTrackedBillLinks: [],
    selectedTrackedBillNotificationsId: 0,
    notificationsRequestCount: 0,
    selectedTrackedBillNotifications: [],
    selectedTrackedBillTrackedBillAgenciesId: 0,
    trackedBillAgenciesRequestCount: 0,
    selectedTrackedBillTrackedBillAgencies: [],
    // selectedTrackedBillUsersId: 0,
    // usersRequestCount: 0,
    // selectedTrackedBillUsers: [],
  },

  getters: {
    // selectedTrackedBillConcern(state) {
    //   return state.selectedTrackedBillConcern
    // },
    // concernLoading(state) {
    //     return state.concernRequestCount > 0
    // },
    // selectedTrackedBillCreatedBy(state) {
    //   return state.selectedTrackedBillCreatedBy
    // },
    // createdByLoading(state) {
    //     return state.createdByRequestCount > 0
    // },
    // selectedTrackedBillPosition(state) {
    //   return state.selectedTrackedBillPosition
    // },
    // positionLoading(state) {
    //     return state.positionRequestCount > 0
    // },
    // selectedTrackedBillPriority(state) {
    //   return state.selectedTrackedBillPriority
    // },
    // priorityLoading(state) {
    //     return state.priorityRequestCount > 0
    // },
    // selectedTrackedBillUpdatedBy(state) {
    //   return state.selectedTrackedBillUpdatedBy
    // },
    // updatedByLoading(state) {
    //     return state.updatedByRequestCount > 0
    // },
    selectedTrackedBillMatchingShared(state) {
      return state.selectedTrackedBillMatchingShared
    },
    matchingSharedLoading(state) {
      return state.matchingSharedRequestCount > 0
    },
    selectedTrackedBillComments(state) {
      return state.selectedTrackedBillComments
    },
    commentsLoading(state) {
      return state.commentsRequestCount > 0
    },
    selectedTrackedBillDocuments(state) {
      return state.selectedTrackedBillDocuments
    },
    documentsLoading(state) {
      return state.documentsRequestCount > 0
    },
    selectedTrackedBillLinks(state) {
      return state.selectedTrackedBillLinks
    },
    linksLoading(state) {
      return state.linksRequestCount > 0
    },
    selectedTrackedBillNotifications(state) {
      return state.selectedTrackedBillNotifications
    },
    notificationsLoading(state) {
      return state.notificationsRequestCount > 0
    },
    selectedTrackedBillTrackedBillAgencies(state) {
      return state.selectedTrackedBillTrackedBillAgencies
    },
    trackedBillAgenciesLoading(state) {
      return state.trackedBillAgenciesRequestCount > 0
    },
    // selectedTrackedBillUsers(state) {
    //   return state.selectedTrackedBillUsers
    // },
    // usersLoading(state) {
    //     return state.usersRequestCount > 0
    // },
  },

  mutations: {
    // selectedTrackedBillConcern(state, payload) {
    //   state.selectedTrackedBillConcern = payload
    // },
    // selectedTrackedBillConcernId(state, payload) {
    //   state.selectedTrackedBillConcernId = payload
    // },
    // concernRequestCount(state, payload) {
    //   state.concernRequestCount = payload
    // },
    // increaseConcernRequestCount(state, payload) {
    //   state.concernRequestCount = state.concernRequestCount + 1
    // },
    // decreaseConcernRequestCount(state, payload) {
    //   state.concernRequestCount = state.concernRequestCount - 1
    // },
    // selectedTrackedBillCreatedBy(state, payload) {
    //   state.selectedTrackedBillCreatedBy = payload
    // },
    // selectedTrackedBillCreatedById(state, payload) {
    //   state.selectedTrackedBillCreatedById = payload
    // },
    // createdByRequestCount(state, payload) {
    //   state.createdByRequestCount = payload
    // },
    // increaseCreatedByRequestCount(state, payload) {
    //   state.createdByRequestCount = state.createdByRequestCount + 1
    // },
    // decreaseCreatedByRequestCount(state, payload) {
    //   state.createdByRequestCount = state.createdByRequestCount - 1
    // },
    // selectedTrackedBillPosition(state, payload) {
    //   state.selectedTrackedBillPosition = payload
    // },
    // selectedTrackedBillPositionId(state, payload) {
    //   state.selectedTrackedBillPositionId = payload
    // },
    // positionRequestCount(state, payload) {
    //   state.positionRequestCount = payload
    // },
    // increasePositionRequestCount(state, payload) {
    //   state.positionRequestCount = state.positionRequestCount + 1
    // },
    // decreasePositionRequestCount(state, payload) {
    //   state.positionRequestCount = state.positionRequestCount - 1
    // },
    // selectedTrackedBillPriority(state, payload) {
    //   state.selectedTrackedBillPriority = payload
    // },
    // selectedTrackedBillPriorityId(state, payload) {
    //   state.selectedTrackedBillPriorityId = payload
    // },
    // priorityRequestCount(state, payload) {
    //   state.priorityRequestCount = payload
    // },
    // increasePriorityRequestCount(state, payload) {
    //   state.priorityRequestCount = state.priorityRequestCount + 1
    // },
    // decreasePriorityRequestCount(state, payload) {
    //   state.priorityRequestCount = state.priorityRequestCount - 1
    // },
    // selectedTrackedBillUpdatedBy(state, payload) {
    //   state.selectedTrackedBillUpdatedBy = payload
    // },
    // selectedTrackedBillUpdatedById(state, payload) {
    //   state.selectedTrackedBillUpdatedById = payload
    // },
    // updatedByRequestCount(state, payload) {
    //   state.updatedByRequestCount = payload
    // },
    // increaseUpdatedByRequestCount(state, payload) {
    //   state.updatedByRequestCount = state.updatedByRequestCount + 1
    // },
    // decreaseUpdatedByRequestCount(state, payload) {
    //   state.updatedByRequestCount = state.updatedByRequestCount - 1
    // },
    selectedTrackedBillMatchingShared(state, payload) {
      state.selectedTrackedBillMatchingShared = payload
    },
    selectedTrackedBillMatchingSharedId(state, payload) {
      state.selectedTrackedBillMatchingSharedId = payload
    },
    matchingSharedRequestCount(state, payload) {
      state.matchingSharedRequestCount = payload
    },
    increaseMatchingSharedRequestCount(state, payload) {
      state.matchingSharedRequestCount = state.matchingSharedRequestCount + 1
    },
    decreaseMatchingSharedRequestCount(state, payload) {
      state.matchingSharedRequestCount = state.matchingSharedRequestCount - 1
    },
    selectedTrackedBillComments(state, payload) {
      state.selectedTrackedBillComments = payload
    },
    selectedTrackedBillCommentsId(state, payload) {
      state.selectedTrackedBillCommentsId = payload
    },
    commentsRequestCount(state, payload) {
      state.commentsRequestCount = payload
    },
    increaseCommentsRequestCount(state, payload) {
      state.commentsRequestCount = state.commentsRequestCount + 1
    },
    decreaseCommentsRequestCount(state, payload) {
      state.commentsRequestCount = state.commentsRequestCount - 1
    },
    selectedTrackedBillDocuments(state, payload) {
      state.selectedTrackedBillDocuments = payload
    },
    selectedTrackedBillDocumentsId(state, payload) {
      state.selectedTrackedBillDocumentsId = payload
    },
    documentsRequestCount(state, payload) {
      state.documentsRequestCount = payload
    },
    increaseDocumentsRequestCount(state, payload) {
      state.documentsRequestCount = state.documentsRequestCount + 1
    },
    decreaseDocumentsRequestCount(state, payload) {
      state.documentsRequestCount = state.documentsRequestCount - 1
    },
    selectedTrackedBillLinks(state, payload) {
      state.selectedTrackedBillLinks = payload
    },
    selectedTrackedBillLinksId(state, payload) {
      state.selectedTrackedBillLinksId = payload
    },
    linksRequestCount(state, payload) {
      state.linksRequestCount = payload
    },
    increaseLinksRequestCount(state, payload) {
      state.linksRequestCount = state.linksRequestCount + 1
    },
    decreaseLinksRequestCount(state, payload) {
      state.linksRequestCount = state.linksRequestCount - 1
    },
    selectedTrackedBillNotifications(state, payload) {
      state.selectedTrackedBillNotifications = payload
    },
    selectedTrackedBillNotificationsId(state, payload) {
      state.selectedTrackedBillNotificationsId = payload
    },
    notificationsRequestCount(state, payload) {
      state.notificationsRequestCount = payload
    },
    increaseNotificationsRequestCount(state, payload) {
      state.notificationsRequestCount = state.notificationsRequestCount + 1
    },
    decreaseNotificationsRequestCount(state, payload) {
      state.notificationsRequestCount = state.notificationsRequestCount - 1
    },
    selectedTrackedBillTrackedBillAgencies(state, payload) {
      state.selectedTrackedBillTrackedBillAgencies = payload
    },
    selectedTrackedBillTrackedBillAgenciesId(state, payload) {
      state.selectedTrackedBillTrackedBillAgenciesId = payload
    },
    trackedBillAgenciesRequestCount(state, payload) {
      state.trackedBillAgenciesRequestCount = payload
    },
    increaseTrackedBillAgenciesRequestCount(state, payload) {
      state.trackedBillAgenciesRequestCount =
        state.trackedBillAgenciesRequestCount + 1
    },
    decreaseTrackedBillAgenciesRequestCount(state, payload) {
      state.trackedBillAgenciesRequestCount =
        state.trackedBillAgenciesRequestCount - 1
    },
    // selectedTrackedBillUsers(state, payload) {
    //   state.selectedTrackedBillUsers = payload
    // },
    // selectedTrackedBillUsersId(state, payload) {
    //   state.selectedTrackedBillUsersId = payload
    // },
    // usersRequestCount(state, payload) {
    //   state.usersRequestCount = payload
    // },
    // increaseUsersRequestCount(state, payload) {
    //   state.usersRequestCount = state.usersRequestCount + 1
    // },
    // decreaseUsersRequestCount(state, payload) {
    //   state.usersRequestCount = state.usersRequestCount - 1
    // },
  },

  actions: {
    // setSelectedTrackedBillConcern(context, payload) {
    //   context.commit('selectedTrackedBillConcern', payload)
    // },
    // async loadSelectedTrackedBillConcern(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillConcern.length > 0 && selectedId != context.state.selectedTrackedBillConcernId ) {
    //       context.commit('selectedTrackedBillConcern', {})
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/Concern'
    //       context.commit('increaseConcernRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillConcern', res.data)
    //       context.commit('selectedTrackedBillConcernId', selectedId)
    //       context.commit('decreaseConcernRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreaseConcernRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },
    // setSelectedTrackedBillCreatedBy(context, payload) {
    //   context.commit('selectedTrackedBillCreatedBy', payload)
    // },
    // async loadSelectedTrackedBillCreatedBy(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillCreatedBy.length > 0 && selectedId != context.state.selectedTrackedBillCreatedById ) {
    //       context.commit('selectedTrackedBillCreatedBy', {})
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/CreatedBy'
    //       context.commit('increaseCreatedByRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillCreatedBy', res.data)
    //       context.commit('selectedTrackedBillCreatedById', selectedId)
    //       context.commit('decreaseCreatedByRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreaseCreatedByRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },
    // setSelectedTrackedBillPosition(context, payload) {
    //   context.commit('selectedTrackedBillPosition', payload)
    // },
    // async loadSelectedTrackedBillPosition(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillPosition.length > 0 && selectedId != context.state.selectedTrackedBillPositionId ) {
    //       context.commit('selectedTrackedBillPosition', {})
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/Position'
    //       context.commit('increasePositionRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillPosition', res.data)
    //       context.commit('selectedTrackedBillPositionId', selectedId)
    //       context.commit('decreasePositionRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreasePositionRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },
    // setSelectedTrackedBillPriority(context, payload) {
    //   context.commit('selectedTrackedBillPriority', payload)
    // },
    // async loadSelectedTrackedBillPriority(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillPriority.length > 0 && selectedId != context.state.selectedTrackedBillPriorityId ) {
    //       context.commit('selectedTrackedBillPriority', {})
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/Priority'
    //       context.commit('increasePriorityRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillPriority', res.data)
    //       context.commit('selectedTrackedBillPriorityId', selectedId)
    //       context.commit('decreasePriorityRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreasePriorityRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },
    // setSelectedTrackedBillUpdatedBy(context, payload) {
    //   context.commit('selectedTrackedBillUpdatedBy', payload)
    // },
    // async loadSelectedTrackedBillUpdatedBy(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillUpdatedBy.length > 0 && selectedId != context.state.selectedTrackedBillUpdatedById ) {
    //       context.commit('selectedTrackedBillUpdatedBy', {})
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/UpdatedBy'
    //       context.commit('increaseUpdatedByRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillUpdatedBy', res.data)
    //       context.commit('selectedTrackedBillUpdatedById', selectedId)
    //       context.commit('decreaseUpdatedByRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreaseUpdatedByRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },

    async loadSelectedTrackedBillMatchingShared(context, payload) {
      if (context.state.selectedTrackedBillId > 0) {
        let selectedId = context.state.selectedTrackedBillId
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillMatchingShared.length > 0 &&
          selectedId != context.state.selectedTrackedBillMatchingSharedId
        ) {
          context.commit('selectedTrackedBillMatchingShared', [])
        }
        try {
          const url = 'TrackedBill/MatchingShared/' + selectedId
          context.commit('increaseMatchingSharedRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.dispatch('setSelectedTrackedBillMatchingShared', res.data)
          context.commit('selectedTrackedBillMatchingSharedId', selectedId)
          context.commit('decreaseMatchingSharedRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseMatchingSharedRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    setSelectedTrackedBillComments(context, payload) {
      context.commit('selectedTrackedBillComments', payload)
    },
    async loadSelectedTrackedBillComments(context, payload) {
      if (context.state.selectedTrackedBillId > 0) {
        let selectedId = context.state.selectedTrackedBillId
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillComments.length > 0 &&
          selectedId != context.state.selectedTrackedBillCommentsId
        ) {
          context.commit('selectedTrackedBillComments', [])
        }
        try {
          const url = 'TrackedBill/' + selectedId + '/Comments'
          context.commit('increaseCommentsRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.commit('selectedTrackedBillComments', res.data)
          context.commit('selectedTrackedBillCommentsId', selectedId)
          context.commit('decreaseCommentsRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseCommentsRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    setSelectedTrackedBillDocuments(context, payload) {
      context.commit('selectedTrackedBillDocuments', payload)
    },
    async loadSelectedTrackedBillDocuments(context, payload) {
      if (context.state.selectedTrackedBillId > 0) {
        let selectedId = context.state.selectedTrackedBillId
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillDocuments.length > 0 &&
          selectedId != context.state.selectedTrackedBillDocumentsId
        ) {
          context.commit('selectedTrackedBillDocuments', [])
        }
        try {
          const url = 'TrackedBill/' + selectedId + '/Documents'
          context.commit('increaseDocumentsRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.commit('selectedTrackedBillDocuments', res.data)
          context.commit('selectedTrackedBillDocumentsId', selectedId)
          context.commit('decreaseDocumentsRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseDocumentsRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    setSelectedTrackedBillLinks(context, payload) {
      context.commit('selectedTrackedBillLinks', payload)
    },
    async loadSelectedTrackedBillLinks(context, payload) {
      if (context.state.selectedTrackedBillId > 0) {
        let selectedId = context.state.selectedTrackedBillId
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillLinks.length > 0 &&
          selectedId != context.state.selectedTrackedBillLinksId
        ) {
          context.commit('selectedTrackedBillLinks', [])
        }
        try {
          const url = 'TrackedBill/' + selectedId + '/Links'
          context.commit('increaseLinksRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.commit('selectedTrackedBillLinks', res.data)
          context.commit('selectedTrackedBillLinksId', selectedId)
          context.commit('decreaseLinksRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseLinksRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    setSelectedTrackedBillNotifications(context, payload) {
      context.commit('selectedTrackedBillNotifications', payload)
    },
    async loadSelectedTrackedBillNotifications(context, payload) {
      if (
        context.state.selectedTrackedBill &&
        context.state.selectedTrackedBill.Id > 0
      ) {
        let selectedId = context.state.selectedTrackedBill.Id
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillNotifications.length > 0 &&
          selectedId != context.state.selectedTrackedBillNotificationsId
        ) {
          context.commit('selectedTrackedBillNotifications', [])
        }
        try {
          const url = 'TrackedBill/' + selectedId + '/Notifications'
          context.commit('increaseNotificationsRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.commit('selectedTrackedBillNotifications', res.data)
          context.commit('selectedTrackedBillNotificationsId', selectedId)
          context.commit('decreaseNotificationsRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseNotificationsRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    setSelectedTrackedBillTrackedBillAgencies(context, payload) {
      context.commit('selectedTrackedBillTrackedBillAgencies', payload)
    },
    async loadSelectedTrackedBillTrackedBillAgencies(context, payload) {
      if (
        context.state.selectedTrackedBill &&
        context.state.selectedTrackedBill.Id > 0
      ) {
        let selectedId = context.state.selectedTrackedBill.Id
        if (
          context.state.selectedTrackedBill &&
          context.state.selectedTrackedBillTrackedBillAgencies.length > 0 &&
          selectedId != context.state.selectedTrackedBillTrackedBillAgenciesId
        ) {
          context.commit('selectedTrackedBillTrackedBillAgencies', [])
        }
        try {
          const url = 'TrackedBill/' + selectedId + '/TrackedBillAgencies'
          context.commit('increaseTrackedBillAgenciesRequestCount')
          let res = await Vue.prototype.$axios.get(url)
          context.commit('selectedTrackedBillTrackedBillAgencies', res.data)
          context.commit('selectedTrackedBillTrackedBillAgenciesId', selectedId)
          context.commit('decreaseTrackedBillAgenciesRequestCount')
          return res
        } catch (err) {
          console.error(err)
          context.commit('decreaseTrackedBillAgenciesRequestCount')
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      }
    },
    // setSelectedTrackedBillUsers(context, payload) {
    //   context.commit('selectedTrackedBillUsers', payload)
    // },
    // async loadSelectedTrackedBillUsers(context, payload) {
    //   if (context.state.selectedTrackedBill && context.state.selectedTrackedBill.Id > 0) {
    //     let selectedId = context.state.selectedTrackedBill.Id
    //     if (context.state.selectedTrackedBill && context.state.selectedTrackedBillUsers.length > 0 && selectedId != context.state.selectedTrackedBillUsersId ) {
    //       context.commit('selectedTrackedBillUsers', [])
    //     }
    //     try {
    //       const url = 'TrackedBill/' + selectedId + '/Users'
    //       context.commit('increaseUsersRequestCount')
    //       let res = await Vue.prototype.$axios.get(url)
    //       context.commit('selectedTrackedBillUsers', res.data)
    //       context.commit('selectedTrackedBillUsersId', selectedId)
    //       context.commit('decreaseUsersRequestCount')
    //       return res
    //     } catch (err) {
    //       console.error(err)
    //       context.commit('decreaseUsersRequestCount')
    //       context.dispatch('errors/handleError', err, { root: true })
    //       throw err
    //     }
    //   }
    // },
  },
}

export default trackedBill
